/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Col, Form, Input, Row, Typography } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

// misc imports
import useTheme from '../../../../utils/hooks/useTheme';
import { FORM_CONFIGURATION_API_INTEGRATION_PATH } from '../../../../constants/deploymentFormPaths';
import { copyTextToClipboard } from '../../../../utils/function/copyToClipboard';

const BotDeploymentsApiStrategyGeneralForm = ({ form, hasEditAccess }) => {
  const { t } = useTranslation();
  const { formProps } = useTheme();
  const jwtToken = Form.useWatch([...FORM_CONFIGURATION_API_INTEGRATION_PATH, 'jwtToken'], form);

  const onCopyToken = () => {
    if (jwtToken) {
      copyTextToClipboard(jwtToken, t('API token copied to clipboard'));
    }
  };

  return (
    <Row gutter={formProps.rowGutter} className={formProps.flexDirection}>
      <Col xs={formProps.mainColSpan}>
        <Row>
          <Col flex="auto">
            <Typography.Text>
              {t('Application Settings')}
            </Typography.Text>

            <Typography.Paragraph className="fs-sm" type="secondary">
              {t('Configure the application settings')}
            </Typography.Paragraph>
          </Col>
        </Row>
      </Col>

      <Col xs={formProps.secondaryColSpan}>
        <Form.Item
          label={t('API Token')}
          name={[...FORM_CONFIGURATION_API_INTEGRATION_PATH, 'jwtToken']}
        >
          <Input readOnly placeholder={t('API token is generated automatically')} suffix={<CopyOutlined className="cursor-pointer" onClick={onCopyToken} />} />
        </Form.Item>
      </Col>
    </Row>
  );
};

BotDeploymentsApiStrategyGeneralForm.propTypes = {
  form: PropTypes.object,
  hasEditAccess: PropTypes.bool
};

export default BotDeploymentsApiStrategyGeneralForm;
